export default __webpack_public_path__ + "static/media/gold E.26ceabbe.png";